module.exports = __webpack_public_path__ + "static/home1-category-page-top-banner-23d65bd2ac914b3a88837ec95d956723.png";